import React, {Fragment} from 'react';
import {Flex, Icon, Form, Edit, Submit, List} from 'components';
import {api} from 'helpers';
import {store} from 'store';

export function DeleteAccount() {
  return (
    <Fragment>
      <h1>Delete Account</h1>
      <Flex className="spacing">
        <Icon name="alert" className="danger" />
        <span>
          This will <b>permanently</b> delete your account and <b>erase all your data.</b>
          This action <b>cannot be undone.</b>
        </span>
      </Flex>
      <Form className="spacing" onSubmit={submit}>
        <List tiny-gutter>
          <span>Type <b>DELETE</b> below to proceed</span>
          <Edit name="confirm" match="DELETE" required validate={value => value != 'DELETE'}  />
          <footer className="smedium-spacing">
            <Submit className="danger">
              {[ 'Delete', 'Deleting..' ]}
            </Submit>
          </footer>
        </List>
      </Form>
    </Fragment>
  );
}

async function submit(values) {
  try {
    await api('/cancel-account/', values);
    store.dispatch({
      type: 'SESSION_LOGOUT',
      notification: 'Your account has been deleted.',
    });
  } catch(error) {
    store.dispatch({
      type: 'UI_ERROR',
      errorMessage: 'Server is not responding. Please try again later.',
      error,
    });
  }
}
